var map = {
	"./branded-asset@3x.png": 7377,
	"./digital-toolkits@3x.png": 6253,
	"./document-repository@3x.png": 1618,
	"./dulux-academy@3x.png": 7001,
	"./focus-of-the-month@3x.png": 2216,
	"./help-videos@3x.png": 632,
	"./industry-events@3x.png": 8157,
	"./industry-insights@3x.png": 4805,
	"./knowledge-base@3x.png": 6267,
	"./new-product-development@3x.png": 9764,
	"./newsletter-repository@3x.png": 7976,
	"./rebate-scheme@3x.png": 1776,
	"./think-forward/npd@3x.png": 122,
	"./video-training@3x.png": 5370,
	"./webshop@3x.png": 647,
	"./work-smarter/work-smarter@3x.png": 5524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5449;